import { useState, FormEvent } from 'react'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom'
import { useAuth } from '../App'
import AuthLayout from '../components/AuthLayout'
import { inputSx, primaryButtonSx } from '../styles/authSx'

const SendReset = () => {
  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const auth = useAuth()

  const canSubmit = email.length > 0 && !submitting

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!canSubmit) return
    setSubmitting(true)
    try {
      await auth?.sendReset(email)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthLayout
      title="Forgot password?"
      subtitle="Enter your email and we'll send you instructions to reset your password."
    >
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <TextField
          fullWidth
          id="email"
          name="email"
          label="Email"
          type="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={inputSx}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disableElevation
          disabled={!canSubmit}
          sx={(t) => ({ ...primaryButtonSx(t), mt: 1 })}
        >
          {submitting ? 'Sending…' : 'Send reset instructions'}
        </Button>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 3
          }}
        >
          <Link
            to="/"
            style={{
              textDecoration: 'none',
              color: '#00A3C4',
              fontSize: '0.8125rem',
              fontWeight: 700
            }}
          >
            ← Back to sign in
          </Link>
        </Box>
      </Box>
    </AuthLayout>
  )
}

export default SendReset
